import gql from 'graphql-tag';

export const GET_FINANCE_PROGRAMS_OPTIONS_LIST_BY_ACCOUNT = gql`
  query GetFinanceProgramsListOptionsByAccount($accountId: ID!) {
    options: financePrograms(accountId: $accountId) {
      value: financeProgramId
      label: nameInternal
    }
  }
`;
